<template>
  <!-- 新增的对话框 修改楼盘佣金 -->
  <el-dialog
    center
    width="750px"
    title="导入"
    :visible.sync="dialogFormVisible"
    top="18vh"
    destroy-on-close
    @close="resetFrom()"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <template>
        <el-form-item label="导入" :label-width="formLabelWidth" prop="file">
          <el-upload
            class="avatar-uploader"
            ref="upload"
            v-loading.fullscreen="Loading"
            element-loading-text="上传中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.1)"
            action=""
            :on-change="fileChange"
            :show-file-list="false"
            :http-request="httpRequest"
            :before-upload="beforeAvatarUpload"
            :auto-upload="false"
          >
            <el-button>选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传xls,xlsx文件
            </div>
            <div slot="tip" class="el-upload__tip">{{ fileName }}</div>
          </el-upload>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="downExcel" style="margin: 0 10px;">上传模板</el-button>
      <el-button
        @click="
          resetFrom();
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" style="margin: 0 10px;" @click="handleSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { formRateData, formRateRules } from '../form.js';
import { uploadExcelFileApi } from '@/api/houseApi.js'; //
import { handleExport } from '@/utils/download.js';
export default {
  name: 'editHousesRate',
  data() {
    return {
      Loading: false,
      title: '',
      rateType: 1,
      houseId: '',
      dialogTitle: '',
      formLabelWidth: '130px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: { ...formRateData, rentBasePoint_1: '', file: '' }, // 编辑表单
      editRules: {
        ...formRateRules,
        file: [
          { required: true, message: 'excel文件不能为空', trigger: 'change' },
        ],
      }, // 表单的验证规则
      fileName: '',
      expireDate: [],
      fileList: [],
      IsOverdue: '', // 是否已经过期了
      houseRateId: '',
    };
  },
  inject: ['reload'],
  computed: {},
  mounted() {},
  methods: {
    //下载模板
    downExcel() {
      let a = document.createElement('a');
      a.href = './楼盘导入模板.xlsx';
      a.download = '楼盘导入模板.xlsx';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isPDF =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (!isPDF) {
        this.$message.error('上传文件只能是xlsx和xls 格式!');
      }

      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isLt2M) {
        this.$message.error('上传Excel文件大小不能超过 20MB!');
      }

      return isPDF && isLt2M;
    },
    resetFrom() {
      this.editForm = { file: '' };
      this.fileName = '';
      this.$refs.editForm.resetFields();
    },
    fileChange(file) {
      this.$refs.editForm.clearValidate('file');
      this.fileName = file.name;
      this.editForm.file = file;
    },
    httpRequest(options) {
      let file = options.file;
      let form = new FormData();
      form.append('file', file);
      this.Loading = true;
      uploadExcelFileApi(form)
        .then((res) => {
          if (res.data?.isHasError === true) {
            this.$confirm('该excel存在错误数据，需要下载修改吗', '提示').then(
              () => {
                let columns = [
                  { title: '序号*', dataIndex: 'number' },
                  { title: '楼盘名称*', dataIndex: 'houseName' },
                  { title: '楼盘来源(填:开始赚/人脸)', dataIndex: 'source' },
                  { title: '所属城市*(填,如:西安)', dataIndex: 'areaId' },
                  { title: '楼盘标签*', dataIndex: 'propertyTag' },
                  { title: '楼盘类型*', dataIndex: 'houseType' },
                  { title: '开盘时间*', dataIndex: 'openingTime' },
                  { title: '占地面积*', dataIndex: 'areaSpace' },
                  { title: '绿化面积*', dataIndex: 'greenSpace' },
                  { title: '绿化率*', dataIndex: 'greenRate' },
                  { title: '容积率*', dataIndex: 'volumeRate' },
                  { title: '楼盘产权', dataIndex: 'property' },
                  { title: '装修情况', dataIndex: 'decoration' },
                  { title: '停车位', dataIndex: 'parkings' },
                  { title: '户型面积', dataIndex: 'roomArea' },

                  { title: '出售价格', dataIndex: 'price' },
                  { title: '出租价格', dataIndex: 'leasePrice' },
                  { title: '楼盘电话', dataIndex: 'phone' },
                  { title: '物业公司', dataIndex: 'propertCompany' },
                  { title: '楼盘地址', dataIndex: 'address' },
                  { title: 'VR地址', dataIndex: 'vrUrl' },
                  { title: '经度*', dataIndex: 'lng' },
                  { title: '纬度*', dataIndex: 'lat' },

                  { title: '初始推荐次数*', dataIndex: 'shareHits' },
                  { title: '排序*', dataIndex: 'sortIndex' },
                  { title: '是否开启(填:是/否)', dataIndex: 'isOpen' },
                  { title: '是否热门(填:是/否)', dataIndex: 'isHot' },
                  {
                    title: '是否预告(填:预告楼盘/正常楼盘)',
                    dataIndex: 'houseStatus',
                  },
                  { title: '失败原因', dataIndex: 'failureReason' },
                ];
                // const data = {};
                // columns.map((i) => {
                //   data[i.dataIndex] = i.title;
                // });
                handleExport(
                  '导入错误数据',
                  columns,
                  [
                    // data,
                    ...res.data.errList,
                  ],
                  `1.带*号为必填；2.楼盘名称不能重复；3.楼盘标签存在多个时，使用英文符号“,”进行分割；4.楼盘类型只能输入高层、洋房、别墅、公寓、商铺、写字楼、存在多个时用英文符号“,”进行分割 `
                );
              }
            );
          } else {
            this.$refs.editForm.resetFields();
            this.$message.success('导入成功!');
            this.$emit('getList');
            this.dialogFormVisible = false;
          }
        })
        .finally(() => {
          this.Loading = false;
        });
    },
    // 新增/编辑
    handleSubmit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (valid) {
            this.$refs.upload.submit();
            // this.dialogFormVisible = false;
            // this.$emit('reload');
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
  created() {},
};
</script>

<style></style>
